// extracted by mini-css-extract-plugin
module.exports = {"cardTitle":"my-bank-card_cardTitle_22Mnz","item":"my-bank-card_item_3VJz7","icon":"my-bank-card_icon_2TEBO","desc":"my-bank-card_desc_21We4","img":"my-bank-card_img_IN_s8"};